import {isEmpty} from 'lodash/fp';

import {UploadCoachImageResponse} from '/component/screen/Profile/ProfileBusinessSection/ManageMySite/ManageMySiteContainer/ManageMySiteContainer.types';
import {targetMap} from '/constant/performanceTargets.constant';
import {COACH_NOTES_STATE_IS_LOADING} from '/enum/coach.enum';
import {RANK_BY_ID} from '/enum/rank.enum';
import {
  FETCH_BONUS_BANNER,
  FETCH_BONUSES,
  FETCH_BUSINESS_PROFILE,
  FETCH_CLIENT,
  FETCH_COACH,
  FETCH_COACH_PERFORMANCE,
  FETCH_COACH_RANK_PROGRESSION,
  FETCH_COACH_TEAMS,
  FETCH_EDGE_365_CHALLENGE_TASKS,
  FETCH_HEALTH_CARE_DATA,
  FETCH_INCENTIVE_TRIP_BONUS_DASHBOARD,
  FETCH_LEADS_POOL,
  FETCH_SAME_DAY_LAST_MONTH,
  FETCH_SOCIAL_MEDIA,
  FETCH_SUPPORTED_LANGUAGES,
  PATCH_BUSINESS_PROFILE,
  PATCH_LEADS_POOL,
  PATCH_SOCIAL_MEDIA,
  POST_COACH_IMAGE,
  PUT_HEALTH_CARE_DATA,
  PUT_SUPPORTED_LANGUAGES,
  REQUEST_PATCH,
  REQUEST_PUT,
  RESET_BUSINESS_PROFILE,
  SET_BUSINESS_PROFILE_ERROR,
  SET_BUSINESS_PROFILE_IMAGE,
  SET_BUSINESS_PROFILE_IMAGE_ERROR,
  SET_BUSINESS_PROFILE_IMAGE_SAVING,
  SET_BUSINESS_PROFILE_LOADING,
  SET_BUSINESS_PROFILE_SAVING,
  SET_HEALTH_CARE_ERROR,
  SET_HEALTH_CARE_LOADING,
  SET_HEALTH_CARE_SAVING,
  SET_LEADS_POOL_ERROR,
  SET_LEADS_POOL_LOADING,
  SET_LEADS_POOL_SAVING,
  SET_SOCIAL_MEDIA_ERROR,
  SET_SOCIAL_MEDIA_LOADING,
  SET_SOCIAL_MEDIA_SAVING,
  SET_SUPPORTED_LANGUAGES_ERROR,
  SET_SUPPORTED_LANGUAGES_LOADING,
  SET_SUPPORTED_LANGUAGES_SAVING,
  UPDATE_EDGE_365_CHALLENGE_TASKS,
} from '/enum/request.enum';
import {RESPONSE_SCHEMA_COACH_PERFORMANCE} from '/enum/responseSchema.enum';
import {request} from '/redux/api/request';
import {
  userId as getUserId,
  userId,
} from '/redux/selector/currentUser.selector';
import {createPromisedAction, handleMissingFields} from '/util/action.util';

import {getErrorHandler} from './apiError.action';
import {setEarnings} from './currentUser.action';
import {
  resetClientProfile,
  resetCoachProfile,
} from './sharedCoachClient.action';

export const GET_RANK_PROGRESSION: string = 'COACH/GET_RANK_PROGRESSION';
export const GET_PERFORMANCE: string = 'COACH/GET_PERFORMANCE';
export const GET_PROFILE: string = 'COACH/GET_PROFILE';
export const GET_TEAMS: string = 'COACH/GET_TEAMS';
export const GET_ACCELERATOR_BONUS: string = 'COACH/GET_ACCELERATOR_BONUS';
export const GET_CSB_PLUS: string = 'COACH/GET_CSB_PLUS';
export const GET_SAME_DAY_LAST_MONTH: string = 'COACH/GET_SAME_DAY_LAST_MONTH';
export const GET_BONUSES: string = 'COACH/GET_BONUSES';
export const GET_INCENTIVE_TRIP_BONUS: string =
  'COACH/GET_INCENTIVE_TRIP_BONUS';
export const GET_BUSINESS_BUILDER_BONUS: string =
  'COACH/GET_BUSINESS_BUILDER_BONUS';
export const GET_BUSINESS_BUILDER_BONUS_CONTRIBUTORS: string =
  'GET_BUSINESS_BUILDER_BONUS_CONTRIBUTORS';

export const SHOW_RANK_PROGRESSION_DETAIL: string =
  'COACH/SHOW_RANK_PROGRESSION_DETAIL';
export const HIDE_RANK_PROGRESSION_DETAIL: string =
  'COACH/HIDE_RANK_PROGRESSION_DETAIL';

export const UPDATE_COACH_PROFILE: string = 'COACH/UPDATE_COACH_PROFILE';

export const SET_COACH_NOTES_STATE: string = 'COACH/SET_COACH_NOTES_STATE';

export const GET_EDGE_365_CHALLENGE_TASKS: string =
  'GET_EDGE_365_CHALLENGE_TASKS';

export const UPSERT_EDGE_365_CHALLENGE_TASKS =
  'UPSERT_EDGE_365_CHALLENGE_TASKS';

export const RESET_EDGE_365_CHALLENGE_TASKS = 'RESET_EDGE_365_CHALLENGE_TASKS';

export const GET_BUSINESS_PROFILE: string = 'COACH/GET_BUSINESS_PROFILE';
export const UPDATE_BUSINESS_PROFILE: string = 'COACH/UPDATE_BUSINESS_PROFILE';

export const GET_SOCIAL_MEDIA: string = 'COACH/GET_SOCIAL_MEDIA';
export const UPDATE_SOCIAL_MEDIA: string = 'COACH/UPDATE_SOCIAL_MEDIA';

export const GET_LEADS_POOL: string = 'COACH/GET_LEADS_POOL';
export const UPDATE_LEADS_POOL: string = 'COACH/UPDATE_LEADS_POOL';

export const GET_HEALTH_CARE_DATA: string = 'COACH/GET_HEALTH_CARE_DATA';
export const UPDATE_HEALTH_CARE_DATA: string = 'COACH/UPDATE_HEALTH_CARE_DATA';

export const GET_SUPPORTED_LANGUAGES: string = 'COACH/GET_SUPPORTED_LANGUAGES';
export const UPDATE_SUPPORTED_LANGUAGES: string =
  'COACH/UPDATE_SUPPORTED_LANGUAGES';

export const UPLOAD_COACH_IMAGE = 'UPLOAD_COACH_IMAGE';

export type CoachImageType = 'avatar' | 'before' | 'after';

export const getRankProgression = createPromisedAction(
  //TODO: currently API doesn't require coachId and rankId as parameters
  GET_RANK_PROGRESSION,
  ['coachId', 'rankId'],
  (dispatchMe: any, inputPayload: any, dispatch: any, getState: any) => {
    const {coachId, rankId} = inputPayload;

    return request(FETCH_COACH_RANK_PROGRESSION, {body: {id: coachId}})
      .then(res => {
        if (userId(getState()) !== coachId) {
          return res;
        }

        const {
          // @ts-expect-error TS(2339): Property 'qualifyingPoints' does not exist on type... Remove this comment to see the full error message
          qualifyingPoints,
          // @ts-expect-error TS(2339): Property 'executiveDirectorTeams' does not exist o... Remove this comment to see the full error message
          executiveDirectorTeams,
          // @ts-expect-error TS(2339): Property 'fqv' does not exist on type '{ data: nul... Remove this comment to see the full error message
          fqv,
          // @ts-expect-error TS(2339): Property 'gqv' does not exist on type '{ data: nul... Remove this comment to see the full error message
          gqv,
          // @ts-expect-error TS(2339): Property 'orderingEntities' does not exist on type... Remove this comment to see the full error message
          orderingEntities,
          ...progression
        } = res;

        return {
          ...progression,
          fqv: {
            ...fqv,
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            target: targetMap.fqv[RANK_BY_ID[rankId]] || fqv.target,
          },
          gqv: {
            ...gqv,
            // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            target: targetMap.gqv[RANK_BY_ID[rankId]] || gqv.target,
          },
          orderingEntities: {
            ...orderingEntities,
            target:
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              targetMap.orderingEntities[RANK_BY_ID[rankId]] ||
              orderingEntities.target,
          },
          qualifyingPoints: {
            ...qualifyingPoints,
            target:
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              targetMap.qualifyingPoints[RANK_BY_ID[rankId]] ||
              qualifyingPoints.target,
          },
          executiveDirectorTeams: {
            ...executiveDirectorTeams,
            target:
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              targetMap.executiveDirectorTeams[RANK_BY_ID[rankId]] ||
              executiveDirectorTeams.target,
          },
        };
      })
      .then(res =>
        dispatchMe(() => ({
          coachId: coachId,
          rankId: rankId,
          progression: res,
        })),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getRankProgression,
          params: inputPayload,
        }),
      );
  },
);

export const getPerformance = createPromisedAction(
  GET_PERFORMANCE,
  ['coachId'],
  (dispatchMe: any, inputPayload: any, dispatch: any, getState: any) => {
    const {coachId} = inputPayload;
    return request(FETCH_COACH_PERFORMANCE, {body: {id: coachId}})
      .then(handleMissingFields(RESPONSE_SCHEMA_COACH_PERFORMANCE))
      .then(({earnings, ...performance}) => {
        dispatchMe(() => ({coachId, performance}));

        if (userId(getState()) === coachId) {
          dispatch(setEarnings({coachId, ...earnings}));
        }
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getPerformance,
          params: inputPayload,
        }),
      );
  },
);

export const getProfile = createPromisedAction(
  GET_PROFILE,
  ['coachId'],
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId, shouldFetchProgression} = inputPayload;

    return request(FETCH_COACH, {body: {id: coachId}})
      .then(coach => dispatchMe(() => ({coachId, coach})))
      .then(({payload: {coach: {nextRank = {}} = {}} = {}}) => {
        if (isEmpty(nextRank) || !shouldFetchProgression) {
          return Promise.resolve();
        } else {
          const {id: rankId} = nextRank;

          return dispatch(getRankProgression({coachId, rankId}));
        }
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getProfile,
          params: inputPayload,
        }),
      );
  },
);

export const getAcceleratorBonusBanner = createPromisedAction(
  GET_ACCELERATOR_BONUS,
  [],
  (dispatchMe: any, inputPayload: any, dispatch: any, getState: any) => {
    return request(FETCH_BONUS_BANNER, {body: {bonusProgramId: 'CAB'}})
      .then(res => dispatchMe(() => ({userId: getUserId(getState()), res})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getAcceleratorBonusBanner,
          params: inputPayload,
        }),
      );
  },
);

export const getClientSupportBonusPlusBanner = createPromisedAction(
  GET_CSB_PLUS,
  [],
  (dispatchMe: any, inputPayload: any, dispatch: any, getState: any) => {
    const doRequest = () =>
      request(FETCH_BONUS_BANNER, {body: {bonusProgramId: 'CSBP'}})
        .then(res => dispatchMe(() => ({userId: getUserId(getState()), res})))
        .catch(
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          getErrorHandler(dispatch, {
            promisedAction: getClientSupportBonusPlusBanner,
            params: inputPayload,
          }),
        );
    return doRequest();
  },
);

export const getTeams = createPromisedAction(
  GET_TEAMS,
  ['coachId'],

  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId} = inputPayload;
    return request(FETCH_COACH_TEAMS, {body: {id: coachId}})
      .then(teams => dispatchMe(() => ({coachId, teams})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getTeams,
          params: inputPayload,
        }),
      );
  },
);

export const showRankProgressionDetail = createPromisedAction(
  SHOW_RANK_PROGRESSION_DETAIL,
  ['coachId', 'rankId', 'targetName'],
);

export const hideRankProgressionDetail = createPromisedAction(
  HIDE_RANK_PROGRESSION_DETAIL,
  ['coachId', 'rankId', 'targetName'],
);

export const getSameDayLastMonth = createPromisedAction(
  GET_SAME_DAY_LAST_MONTH,
  ['coachId'],

  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId} = inputPayload;
    return request(FETCH_SAME_DAY_LAST_MONTH, {body: {id: coachId}})
      .then(res => dispatchMe(() => ({coachId, res})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getSameDayLastMonth,
          params: inputPayload,
        }),
      );
  },
);

export const getBonuses = createPromisedAction(
  GET_BONUSES,
  ['date, formattedCurrentPeriod'],
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {date, formattedCurrentPeriod} = inputPayload;
    return request(FETCH_BONUSES, {body: {date}})
      .then(bonuses => dispatchMe(() => ({bonuses, formattedCurrentPeriod})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getBonuses,
          params: inputPayload,
        }),
      );
  },
);

export const getIncentiveTripBonusBanner = createPromisedAction(
  GET_INCENTIVE_TRIP_BONUS,
  [],
  (dispatchMe: any, inputPayload: any, dispatch: any, getState: any) => {
    return request(FETCH_INCENTIVE_TRIP_BONUS_DASHBOARD)
      .then(res => dispatchMe(() => ({userId: getUserId(getState()), res})))
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getIncentiveTripBonusBanner,
          params: inputPayload,
        }),
      );
  },
);

export const setCoachNotesState = createPromisedAction(SET_COACH_NOTES_STATE, [
  'coachId',
  'stateName',
  'stateValue',
]);
export const updateCoachNotes = createPromisedAction(
  UPDATE_COACH_PROFILE,
  ['coachId', 'body'],
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId, body} = inputPayload;
    return Promise.resolve()
      .then(() =>
        // Finally set the loading state back to false.
        dispatch(
          setCoachNotesState({
            coachId,
            stateName: COACH_NOTES_STATE_IS_LOADING,
            stateValue: true,
          }),
        ),
      )
      .then(() =>
        request(FETCH_CLIENT, {
          URLParams: JSON.stringify(coachId),
          body: body,
          method: REQUEST_PUT,
        }),
      )
      .then(coach => {
        dispatchMe(() => ({coachId, coach}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: updateCoachNotes,
          params: inputPayload,
        }),
      )
      .then(() => {
        // Calling coachId api to reload the updated data
        dispatch(resetCoachProfile({coachId}));
      })
      .then(() => {
        // Calling client api to reload the updated data
        dispatch(resetClientProfile({clientId: coachId}));
      })
      .then(() => {
        // Calling coach api to reload the updated data
        dispatch(getProfile({coachId}));
      })
      .then(() =>
        // Finally set the loading state back to false.
        dispatch(
          setCoachNotesState({
            coachId,
            stateName: COACH_NOTES_STATE_IS_LOADING,
            stateValue: false,
          }),
        ),
      )
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: resetCoachProfile,
          params: coachId,
        }),
      );
  },
);

export const getEdge365ChallengeTasks = createPromisedAction(
  GET_EDGE_365_CHALLENGE_TASKS,
  ['coachId', 'month', 'year'],
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId, month, year} = inputPayload;
    return request(FETCH_EDGE_365_CHALLENGE_TASKS, {
      body: {id: coachId, month, year},
    })
      .then(res => {
        dispatchMe(() => ({coachId, res}));
        return res;
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: getEdge365ChallengeTasks,
          params: inputPayload,
        }),
      );
  },
);

export const upsertEdge365ChallengeTasks = createPromisedAction(
  UPSERT_EDGE_365_CHALLENGE_TASKS,
  ['coachId', 'payload'],
  (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {coachId, payload} = inputPayload;
    const {month, year, ...restPayload} = payload;
    return request(UPDATE_EDGE_365_CHALLENGE_TASKS, {
      method: REQUEST_PUT,
      params: {id: coachId},
      body: restPayload,
    })
      .then(res => {
        dispatchMe(() => ({coachId, res}));
      })
      .then(() => {
        // dispatch(resetEdge365ChallengeTasks({coachId}));
        // Chain GET call using extracted month and year
        return dispatch(getEdge365ChallengeTasks({coachId, month, year}));
      })
      .catch(
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        getErrorHandler(dispatch, {
          promisedAction: upsertEdge365ChallengeTasks,
          params: inputPayload,
        }),
      );
  },
);

export const resetEdge365ChallengeTasks = createPromisedAction(
  RESET_EDGE_365_CHALLENGE_TASKS,
  ['coachId'],
);

export const setBusinessProfileLoading = createPromisedAction(
  SET_BUSINESS_PROFILE_LOADING,
  ['isLoading'],
);

export const setBusinessProfileSaving = createPromisedAction(
  SET_BUSINESS_PROFILE_SAVING,
  ['isSaving'],
);

export const setBusinessProfileError = createPromisedAction(
  SET_BUSINESS_PROFILE_ERROR,
  ['hasError'],
);

export const resetBusinessProfile = createPromisedAction(
  RESET_BUSINESS_PROFILE,
  [],
);
export const getBusinessProfile = createPromisedAction(
  GET_BUSINESS_PROFILE,
  [],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setBusinessProfileLoading({isLoading: true}));
    dispatch(setBusinessProfileError({hasError: false}));

    try {
      const res = await request(FETCH_BUSINESS_PROFILE);

      dispatchMe(() => ({
        businessProfile: res,
      }));

      return res;
    } catch (err: any) {
      dispatch(setBusinessProfileError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: getBusinessProfile,
        params: inputPayload,
      })(err);

      return null;
    } finally {
      dispatch(setBusinessProfileLoading({isLoading: false}));
    }
  },
);

export const patchBusinessProfile = createPromisedAction(
  UPDATE_BUSINESS_PROFILE,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setBusinessProfileSaving({isSaving: true}));
    dispatch(setBusinessProfileError({hasError: false}));

    try {
      const res = await request(PATCH_BUSINESS_PROFILE, {
        method: REQUEST_PATCH,
        body: inputPayload,
      });

      return res;
    } catch (err: any) {
      dispatch(setBusinessProfileError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: patchBusinessProfile,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setBusinessProfileSaving({isSaving: false}));
    }
  },
);

export const setSocialMediaLoading = createPromisedAction(
  SET_SOCIAL_MEDIA_LOADING,
  ['isLoading'],
);

export const setSocialMediaSaving = createPromisedAction(
  SET_SOCIAL_MEDIA_SAVING,
  ['isSaving'],
);

export const setSocialMediaError = createPromisedAction(
  SET_SOCIAL_MEDIA_ERROR,
  ['hasError'],
);

export const getSocialMedia = createPromisedAction(
  GET_SOCIAL_MEDIA,
  [],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setSocialMediaLoading({isLoading: true}));
    dispatch(setSocialMediaError({hasError: false}));

    try {
      const res: any = await request(FETCH_SOCIAL_MEDIA);
      const socialNetworks = res?.socialNetworks || res;

      dispatchMe(() => ({
        socialMedia: socialNetworks,
      }));

      return socialNetworks;
    } catch (err: any) {
      dispatch(setSocialMediaError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: getSocialMedia,
        params: inputPayload,
      })(err);

      return null;
    } finally {
      dispatch(setSocialMediaLoading({isLoading: false}));
    }
  },
);

export const patchSocialMedia = createPromisedAction(
  UPDATE_SOCIAL_MEDIA,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setSocialMediaSaving({isSaving: true}));
    dispatch(setSocialMediaError({hasError: false}));

    try {
      const res = await request(PATCH_SOCIAL_MEDIA, {
        method: REQUEST_PATCH,
        body: inputPayload,
      });

      return res;
    } catch (err: any) {
      dispatch(setSocialMediaError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: patchSocialMedia,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setSocialMediaSaving({isSaving: false}));
    }
  },
);

export const setLeadsPoolLoading = createPromisedAction(
  SET_LEADS_POOL_LOADING,
  ['isLoading'],
);

export const setLeadsPoolSaving = createPromisedAction(SET_LEADS_POOL_SAVING, [
  'isSaving',
]);

export const setLeadsPoolError = createPromisedAction(SET_LEADS_POOL_ERROR, [
  'hasError',
]);

export const getLeadsPool = createPromisedAction(
  GET_LEADS_POOL,
  [],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setLeadsPoolLoading({isLoading: true}));
    dispatch(setLeadsPoolError({hasError: false}));

    try {
      const res = await request(FETCH_LEADS_POOL);

      dispatchMe(() => ({
        leadsPool: res,
      }));

      return res;
    } catch (err: any) {
      dispatch(setLeadsPoolError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: getLeadsPool,
        params: inputPayload,
      })(err);

      return null;
    } finally {
      dispatch(setLeadsPoolLoading({isLoading: false}));
    }
  },
);

export const patchLeadsPool = createPromisedAction(
  UPDATE_LEADS_POOL,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setLeadsPoolSaving({isSaving: true}));
    dispatch(setLeadsPoolError({hasError: false}));

    try {
      const res = await request(PATCH_LEADS_POOL, {
        method: REQUEST_PATCH,
        body: inputPayload,
      });

      return res;
    } catch (err: any) {
      dispatch(setLeadsPoolError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: patchLeadsPool,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setLeadsPoolSaving({isSaving: false}));
    }
  },
);

export const setHealthcareLoading = createPromisedAction(
  SET_HEALTH_CARE_LOADING,
  ['isLoading'],
);

export const setHealthcareSaving = createPromisedAction(
  SET_HEALTH_CARE_SAVING,
  ['isSaving'],
);

export const setHealthcareError = createPromisedAction(SET_HEALTH_CARE_ERROR, [
  'hasError',
]);

export const getHealthcareData = createPromisedAction(
  GET_HEALTH_CARE_DATA,
  [],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setHealthcareLoading({isLoading: true}));
    dispatch(setHealthcareError({hasError: false}));

    try {
      const res = await request(FETCH_HEALTH_CARE_DATA);

      dispatchMe(() => ({
        healthcare: res,
      }));

      return res;
    } catch (err: any) {
      dispatch(setHealthcareError({hasError: true}));
      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: getHealthcareData,
        params: inputPayload,
      })(err);

      return null;
    } finally {
      dispatch(setHealthcareLoading({isLoading: false}));
    }
  },
);

export const putHealthcareData = createPromisedAction(
  UPDATE_HEALTH_CARE_DATA,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setHealthcareSaving({isSaving: true}));
    dispatch(setHealthcareError({hasError: false}));

    try {
      const res = await request(PUT_HEALTH_CARE_DATA, {
        method: REQUEST_PUT,
        body: inputPayload,
      });

      return res;
    } catch (err: any) {
      dispatch(setHealthcareError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: putHealthcareData,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setHealthcareSaving({isSaving: false}));
    }
  },
);

export const setSupportedLanguagesLoading = createPromisedAction(
  SET_SUPPORTED_LANGUAGES_LOADING,
  ['isLoading'],
);

export const setSupportedLanguagesSaving = createPromisedAction(
  SET_SUPPORTED_LANGUAGES_SAVING,
  ['isSaving'],
);

export const setSupportedLanguagesError = createPromisedAction(
  SET_SUPPORTED_LANGUAGES_ERROR,
  ['hasError'],
);

export const getSupportedLanguages = createPromisedAction(
  GET_SUPPORTED_LANGUAGES,
  [],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setSupportedLanguagesLoading({isLoading: true}));
    dispatch(setSupportedLanguagesError({hasError: false}));

    try {
      const res = await request(FETCH_SUPPORTED_LANGUAGES);

      dispatchMe(() => ({
        supportedLanguages: res,
      }));

      return res;
    } catch (err: any) {
      dispatch(setSupportedLanguagesError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: getSupportedLanguages,
        params: inputPayload,
      })(err);

      return null;
    } finally {
      dispatch(setSupportedLanguagesLoading({isLoading: false}));
    }
  },
);

export const putSupportedLanguages = createPromisedAction(
  UPDATE_SUPPORTED_LANGUAGES,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    dispatch(setSupportedLanguagesSaving({isSaving: true}));
    dispatch(setSupportedLanguagesError({hasError: false}));

    try {
      const res = await request(PUT_SUPPORTED_LANGUAGES, {
        method: REQUEST_PUT,
        body: inputPayload,
      });

      return res;
    } catch (err: any) {
      dispatch(setSupportedLanguagesError({hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: putSupportedLanguages,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setSupportedLanguagesSaving({isSaving: false}));
    }
  },
);

export const setBusinessProfileImage = createPromisedAction(
  SET_BUSINESS_PROFILE_IMAGE,
  ['imageType', 'url'],
);

export const setBusinessProfileImageSaving = createPromisedAction(
  SET_BUSINESS_PROFILE_IMAGE_SAVING,
  ['imageType', 'isSaving'],
);

export const setBusinessProfileImageError = createPromisedAction(
  SET_BUSINESS_PROFILE_IMAGE_ERROR,
  ['imageType', 'hasError'],
);

const stripBase64Prefix = (value: string = ''): string =>
  String(value).replace(/^data:image\/[a-zA-Z0-9+.-]+;base64,/, '');

export const uploadBusinessProfileImage = createPromisedAction(
  UPLOAD_COACH_IMAGE,
  ['inputPayload'],
  async (dispatchMe: any, inputPayload: any, dispatch: any) => {
    const {imageType, base64 = '', mimeType = 'image/jpeg'} = inputPayload;

    const cleanBase64 = stripBase64Prefix(base64);

    const realDispatch = typeof dispatch === 'function' ? dispatch : dispatchMe;

    dispatch(setBusinessProfileImageSaving({imageType, isSaving: true}));
    dispatch(setBusinessProfileImageError({imageType, hasError: false}));

    try {
      const res = (await request(POST_COACH_IMAGE, {
        method: 'POST',
        body: cleanBase64,
        isRawBody: true,
        params: {
          imageType,
        },
        additionalHeaders: {
          'Content-Type': mimeType,
        },
      })) as UploadCoachImageResponse;

      realDispatch(
        setBusinessProfileImage({
          imageType: res?.imageType || imageType,
          url: res?.imageUrl || '',
        }),
      );

      return res;
    } catch (err: any) {
      dispatch(setBusinessProfileImageError({imageType, hasError: true}));

      // @ts-expect-error
      getErrorHandler(dispatch, {
        promisedAction: uploadBusinessProfileImage,
        params: inputPayload,
      })(err);

      throw err;
    } finally {
      dispatch(setBusinessProfileImageSaving({imageType, isSaving: false}));
    }
  },
);

export interface WebImageOverrideState {
  avatar: string | null;
  before: string | null;
  after: string | null;
}

export const SET_WEB_AVATAR_OVERRIDE =
  'WEB_IMAGE_OVERRIDE/SET_WEB_AVATAR_OVERRIDE';
export const SET_WEB_BEFORE_OVERRIDE =
  'WEB_IMAGE_OVERRIDE/SET_WEB_BEFORE_OVERRIDE';
export const SET_WEB_AFTER_OVERRIDE =
  'WEB_IMAGE_OVERRIDE/SET_WEB_AFTER_OVERRIDE';
export const CLEAR_WEB_AVATAR_OVERRIDE =
  'WEB_IMAGE_OVERRIDE/CLEAR_WEB_AVATAR_OVERRIDE';
export const CLEAR_WEB_PROFILE_IMAGE_OVERRIDES =
  'WEB_IMAGE_OVERRIDE/CLEAR_WEB_PROFILE_IMAGE_OVERRIDES';

export const setWebAvatarOverride = (avatar: string | null) => ({
  type: SET_WEB_AVATAR_OVERRIDE,
  payload: avatar,
});

export const setWebBeforeOverride = (before: string | null) => ({
  type: SET_WEB_BEFORE_OVERRIDE,
  payload: before,
});

export const setWebAfterOverride = (after: string | null) => ({
  type: SET_WEB_AFTER_OVERRIDE,
  payload: after,
});

export const clearWebAvatarOverride = () => ({
  type: CLEAR_WEB_AVATAR_OVERRIDE,
});

export const clearWebProfileImageOverrides = () => ({
  type: CLEAR_WEB_PROFILE_IMAGE_OVERRIDES,
});
